import { type ChipLevel, type ColorVariant } from "./types";

export const LEVEL_VARIANT_CLASSES: Record<
	ChipLevel,
	Record<
		ColorVariant,
		{
			background: string;
			text: string;
			icon: string;
			hover: string;
			groupHover: string;
			iconHover: string;
			active: string;
			groupActive: string;
			iconActive: string;
		}
	>
> = {
	primary: {
		default: {
			background: "bg-dark-spectrum-gray",
			text: "text-light-spectrum-gray",
			icon: "fill-light-spectrum-gray",
			hover: "hover:bg-dark-spectrum-gray-hover",
			groupHover: "group-hover:bg-dark-spectrum-gray-hover",
			// light- to get a little more contrast, gray is unusually light because dark mode has a
			// dark gray bg.
			iconHover: "fill-light-spectrum-gray",
			active: "active:bg-dark-spectrum-gray-active",
			groupActive: "group-active:bg-dark-spectrum-gray-active",
			// not -hover as the rest are, to get a little more contrast, gray is unusually light
			// because dark mode has a dark gray bg.
			iconActive: "group-active:fill-light-spectrum-gray",
		},
		red: {
			background: "bg-dark-spectrum-red",
			text: "text-light-spectrum-red",
			icon: "fill-light-spectrum-red",
			hover: "hover:bg-dark-spectrum-red-hover",
			groupHover: "group-hover:bg-dark-spectrum-red-hover",
			iconHover: "fill-light-spectrum-red-hover",
			active: "active:bg-dark-spectrum-red-active",
			groupActive: "group-active:bg-dark-spectrum-red-active",
			iconActive: "group-active:fill-light-spectrum-red-hover",
		},
		yellow: {
			background: "bg-dark-spectrum-yellow",
			text: "text-light-spectrum-yellow",
			icon: "fill-light-spectrum-yellow",
			hover: "hover:bg-dark-spectrum-yellow-hover",
			groupHover: "group-hover:bg-dark-spectrum-yellow-hover",
			iconHover: "fill-light-spectrum-yellow-hover",
			active: "active:bg-dark-spectrum-yellow-active",
			groupActive: "group-active:bg-dark-spectrum-yellow-active",
			iconActive: "group-active:fill-light-spectrum-yellow-hover",
		},
		green: {
			background: "bg-dark-spectrum-green",
			text: "text-light-spectrum-green",
			icon: "fill-light-spectrum-green",
			hover: "hover:bg-dark-spectrum-green-hover",
			groupHover: "group-hover:bg-dark-spectrum-green-hover",
			iconHover: "fill-light-spectrum-green-hover",
			active: "active:bg-dark-spectrum-green-active",
			groupActive: "group-active:bg-dark-spectrum-green-active",
			iconActive: "group-active:fill-light-spectrum-green-hover",
		},
		cyan: {
			background: "bg-dark-spectrum-cyan",
			text: "text-light-spectrum-cyan",
			icon: "fill-light-spectrum-cyan",
			hover: "hover:bg-dark-spectrum-cyan-hover",
			groupHover: "group-hover:bg-dark-spectrum-cyan-hover",
			iconHover: "fill-light-spectrum-cyan-hover",
			active: "active:bg-dark-spectrum-cyan-active",
			groupActive: "group-active:bg-dark-spectrum-cyan-active",
			iconActive: "group-active:fill-light-spectrum-cyan-hover",
		},
		blue: {
			background: "bg-dark-spectrum-blue",
			text: "text-light-spectrum-blue",
			icon: "fill-light-spectrum-blue",
			hover: "hover:bg-dark-spectrum-blue-hover",
			groupHover: "group-hover:bg-dark-spectrum-blue-hover",
			iconHover: "fill-light-spectrum-blue-hover",
			active: "active:bg-dark-spectrum-blue-active",
			groupActive: "group-active:bg-dark-spectrum-blue-active",
			iconActive: "group-active:fill-light-spectrum-blue-hover",
		},
		purple: {
			background: "bg-dark-spectrum-purple",
			text: "text-light-spectrum-purple",
			icon: "fill-light-spectrum-purple",
			hover: "hover:bg-dark-spectrum-purple-hover",
			groupHover: "group-hover:bg-dark-spectrum-purple-hover",
			iconHover: "fill-light-spectrum-purple-hover",
			active: "active:bg-dark-spectrum-purple-active",
			groupActive: "group-active:bg-dark-spectrum-purple-active",
			iconActive: "group-active:fill-light-spectrum-purple-hover",
		},
		pink: {
			background: "bg-dark-spectrum-pink",
			text: "text-light-spectrum-pink",
			icon: "fill-light-spectrum-pink",
			hover: "hover:bg-dark-spectrum-pink-hover",
			groupHover: "group-hover:bg-dark-spectrum-pink-hover",
			iconHover: "fill-light-spectrum-pink-hover",
			active: "active:bg-dark-spectrum-pink-active",
			groupActive: "group-active:bg-dark-spectrum-pink-active",
			iconActive: "group-active:fill-light-spectrum-pink-hover",
		},
	},
	secondary: {
		default: {
			background: "bg-light-spectrum-gray",
			text: "text-dark-spectrum-gray",
			icon: "fill-dark-spectrum-gray",
			hover: "hover:bg-light-spectrum-gray-hover",
			groupHover: "group-hover:bg-light-spectrum-gray-hover",
			// light- to get a little more contrast, gray is unusually light because dark mode has a
			// dark gray bg.
			iconHover: "fill-dark-spectrum-gray",
			active: "active:bg-light-spectrum-gray-active",
			groupActive: "group-active:bg-light-spectrum-gray-active",
			// not -hover as the rest are, to get a little more contrast, gray is unusually light
			// because dark mode has a dark gray bg.
			iconActive: "group-active:fill-dark-spectrum-gray",
		},
		red: {
			background: "bg-light-spectrum-red",
			text: "text-dark-spectrum-red",
			icon: "fill-dark-spectrum-red",
			hover: "hover:bg-light-spectrum-red-hover",
			groupHover: "group-hover:bg-light-spectrum-red-hover",
			iconHover: "fill-dark-spectrum-red-hover",
			active: "active:bg-light-spectrum-red-active",
			groupActive: "group-active:bg-light-spectrum-red-active",
			iconActive: "group-active:fill-dark-spectrum-red-hover",
		},
		yellow: {
			background: "bg-light-spectrum-yellow",
			text: "text-dark-spectrum-yellow",
			icon: "fill-dark-spectrum-yellow",
			hover: "hover:bg-light-spectrum-yellow-hover",
			groupHover: "group-hover:bg-light-spectrum-yellow-hover",
			iconHover: "fill-dark-spectrum-yellow-hover",
			active: "active:bg-light-spectrum-yellow-active",
			groupActive: "group-active:bg-light-spectrum-yellow-active",
			iconActive: "group-active:fill-dark-spectrum-yellow-hover",
		},
		green: {
			background: "bg-light-spectrum-green",
			text: "text-dark-spectrum-green",
			icon: "fill-dark-spectrum-green",
			hover: "hover:bg-light-spectrum-green-hover",
			groupHover: "group-hover:bg-light-spectrum-green-hover",
			iconHover: "fill-dark-spectrum-green-hover",
			active: "active:bg-light-spectrum-green-active",
			groupActive: "group-active:bg-light-spectrum-green-active",
			iconActive: "group-active:fill-dark-spectrum-green-hover",
		},
		cyan: {
			background: "bg-light-spectrum-cyan",
			text: "text-dark-spectrum-cyan",
			icon: "fill-dark-spectrum-cyan",
			hover: "hover:bg-light-spectrum-cyan-hover",
			groupHover: "group-hover:bg-light-spectrum-cyan-hover",
			iconHover: "fill-dark-spectrum-cyan-hover",
			active: "active:bg-light-spectrum-cyan-active",
			groupActive: "group-active:bg-light-spectrum-cyan-active",
			iconActive: "group-active:fill-dark-spectrum-cyan-hover",
		},
		blue: {
			background: "bg-light-spectrum-blue",
			text: "text-dark-spectrum-blue",
			icon: "fill-dark-spectrum-blue",
			hover: "hover:bg-light-spectrum-blue-hover",
			groupHover: "group-hover:bg-light-spectrum-blue-hover",
			iconHover: "fill-dark-spectrum-blue-hover",
			active: "active:bg-light-spectrum-blue-active",
			groupActive: "group-active:bg-light-spectrum-blue-active",
			iconActive: "group-active:fill-dark-spectrum-blue-hover",
		},
		purple: {
			background: "bg-light-spectrum-purple",
			text: "text-dark-spectrum-purple",
			icon: "fill-dark-spectrum-purple",
			hover: "hover:bg-light-spectrum-purple-hover",
			groupHover: "group-hover:bg-light-spectrum-purple-hover",
			iconHover: "fill-dark-spectrum-purple-hover",
			active: "active:bg-light-spectrum-purple-active",
			groupActive: "group-active:bg-light-spectrum-purple-active",
			iconActive: "group-active:fill-dark-spectrum-purple-hover",
		},
		pink: {
			background: "bg-light-spectrum-pink",
			text: "text-dark-spectrum-pink",
			icon: "fill-dark-spectrum-pink",
			hover: "hover:bg-light-spectrum-pink-hover",
			groupHover: "group-hover:bg-light-spectrum-pink-hover",
			iconHover: "fill-dark-spectrum-pink-hover",
			active: "active:bg-light-spectrum-pink-active",
			groupActive: "group-active:bg-light-spectrum-pink-active",
			iconActive: "group-active:fill-dark-spectrum-pink-hover",
		},
	},
};
